import { Card } from '@/components/ui/Card'
import { cn } from '@/components/ui/cn'

function Skeleton({ className }: { className?: string }) {
  return <div className={cn('animate-pulse rounded-md bg-muted', className)} />
}

export function DashboardSkeleton() {
  return (
    <div className="space-y-4" data-testid="dashboard-skeleton">
      <Skeleton className="h-[88px] w-full rounded-xl" />
      <Card className="overflow-hidden">
        <div className="border-b px-5 py-4">
          <div className="flex gap-3">
            <Skeleton className="h-14 flex-1 rounded-lg" />
            <Skeleton className="h-14 flex-1 rounded-lg" />
          </div>
        </div>
        <div className="grid md:grid-cols-2 md:divide-x">
          <Skeleton className="h-44 border-b md:border-b-0" />
          <Skeleton className="h-44" />
        </div>
      </Card>
      <Card className="p-5">
        <Skeleton className="mb-4 h-5 w-24" />
        <div className="grid gap-4 md:grid-cols-3">
          <Skeleton className="h-28 rounded-xl" />
          <Skeleton className="h-28 rounded-xl" />
          <Skeleton className="h-28 rounded-xl" />
        </div>
      </Card>
    </div>
  )
}
